<script setup lang="ts">
import { ShoppingBag } from 'lucide-vue-next'

import type { CustomerOrderPartner } from '@/types/customer/Order'

withDefaults(
  defineProps<{
    partner: CustomerOrderPartner | null
    size?: 'sm' | 'md'
  }>(),
  {
    size: 'md'
  }
)
</script>

<template>
  <Avatar class="shrink-0 border bg-white" :class="size === 'sm' ? 'size-7' : 'size-10'">
    <AvatarImage
      v-if="partner?.logoUrl"
      :src="partner.logoUrl"
      :alt="partner.name"
      class="object-contain"
      :class="size === 'sm' ? 'p-1' : 'p-1.5'"
    />
    <AvatarFallback class="bg-violet-50 text-violet-700">
      <ShoppingBag :class="size === 'sm' ? 'size-3.5' : 'size-5'" />
    </AvatarFallback>
  </Avatar>
</template>
